
function newRouteItem (route, title, subLinks) {
  return {
    route: route,
    title: title,
    subLinks: subLinks
  };
}

export const navMixin = {
  data () {
    return {
      routes: {
        NextSteps: newRouteItem('NextSteps', 'Next Steps', {}),
        Home: newRouteItem('Home', 'Home', {}),
        BusinessSite: newRouteItem('BusinessSite', 'Business Services', {}),
        Careers: newRouteItem('Careers', 'Careers', {}),
        AboutUs: newRouteItem('AboutUs', 'About Us', {}),
        FAQ: newRouteItem('FAQ', 'FAQ', {}),
        Help: newRouteItem('Help', 'Help', {}),
        ContactUs: newRouteItem('ContactUs', 'Contact Us', {})
      }
    };
  },
  computed: {
    activeRoute () {
      return this.$route.name;
    }
  },
  methods: {
    routesToArray (routesObj) {
      const arr = Object.entries(routesObj).map((key) => key[1]);
      arr.forEach(x => {
        x.subLinks = Object.keys(x.subLinks).length > 0 ? this.routesToArray(x.subLinks) : [];
      });
      return arr;
    },
    getNavIcon (navRoute) {
      switch (navRoute) {
        case 'Home':
          return 'fas fa-home-lg-alt';
        case 'NextSteps':
          return 'fas fa-route';
        case 'MyAccount':
          return 'fas fa-briefcase';
        case 'Careers':
          return 'fas fa-briefcase';
        case 'BusinessSite':
          return 'fas fa-globe';  
        case 'AboutUs':
          return 'fas fa-user-group';
        case 'ContactUs':
          return 'fas fa-comment-alt';
        case 'Help':
          return 'fas fa-question';
        case 'FAQ':
          return 'fas fa-question';
        default:
          return 'fas fa-hashtag';
      }
    }
  }
}
